
import React from 'react'
import Builder from '../../Components/Bulider/Builder'
import Header from '../../Components/LoginFloder/Header'
const Builders = () => {
  return (
    <div>
        <Header />
        <Builder />
    </div>
  )
}

export default Builders
